  /* function addClass() {
        var jdgmWidget = document.querySelector('#judgeme_product_reviews');
        jdgmWidget.classList.add('container');
        }
      setTimeout(addClass, 500);
*/
window.addEventListener('jdgm.doneSetup', function() {
  if (window.location.pathname.includes('/de/')) {
    const reviewTexts = document.querySelectorAll('.jdgm-prev-badge__text');
    reviewTexts.forEach(function(el) {
      el.textContent = el.textContent.replace('reviews', 'Bewertungen');
    });
  }
  
  const hiddenElements = document.querySelectorAll('.bls__product-review-sold .jdgm-prev-badge__text');
  hiddenElements.forEach(function(el) {
    el.style.visibility = 'visible';
  });
});
